import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

export const WHATSAPP_NUMBER = "4368864297181";
export const WHATSAPP_DISPLAY = "+43 688 64297181";
export const EMAIL = "webhauswien@icloud.com";
export const MAILTO = "mailto:webhauswien@icloud.com";

export function whatsappLink(example) {
  let text = "Hallo Webhaus, ich interessiere mich für eine kostenlose Website-Demo.";
  if (example) text += ` Mir gefällt das Designbeispiel „${example}“.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function errorText(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg?.replace(/^Value error, /, "")).filter(Boolean).join(" ");
  if (!err?.response) return "Keine Verbindung zum Server. Bitte prüfen Sie Ihre Internetverbindung.";
  return fallback;
}

export function newToken() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
